export default "__VITE_ASSET__Bi9c60AG__"